import { useEffect } from 'react';

function Billing() {
    useEffect(() => {
        // Redirect to Stripe billing portal
        window.location.href = 'https://billing.tb2.health/p/login/dR65mMaQo1of56o7ss';
    }, []);

    return null;
}

export default Billing;
